module.exports = __webpack_public_path__ + "static/scale-model-of-six-flags-over-texas-in-arlington-texas-42456c6a5c15c4b68c9464c8b83da700.png";